import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-white pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-25">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-26">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-blue-50 blur-3xl opacity-60" data-id="element-27" />
        <div className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-blue-100 blur-3xl opacity-40" data-id="element-28" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-30">
          <h1 className="text-5xl md:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.1] mb-6" data-id="element-31">
            AI Hiring Consulting for{' '}
            <span className="text-blue-700" data-id="element-32">Small Businesses</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
          Implement AI to Hire Faster, Fairer, and at a Fraction of the Cost. We
          help small businesses use practical AI in hiring without enterprise
          budgets or technical complexity.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center gap-4" data-id="element-34">
          <motion.a href="https://meetings.hubspot.com/mike745/consulting-meet-for-small-businesses" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05,
          boxShadow: '0 10px 25px -5px rgba(245, 158, 11, 0.4)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-amber-500 hover:bg-amber-600 text-white text-lg font-bold py-4 px-8 rounded-lg shadow-lg transition-colors flex items-center gap-2" data-id="element-35">
            Book Free Consultation <ArrowRight className="w-5 h-5" data-id="element-36" />
          </motion.a>

          <p className="text-sm text-slate-500 font-medium" data-id="element-37">
            No commitment • No jargon • Real results in weeks, not quarters
          </p>
        </motion.div>
      </div>
    </section>;
}